import { render, staticRenderFns } from "./WheelHistoryRoundColors.vue?vue&type=template&id=1f67b6fd&scoped=true&"
import script from "./WheelHistoryRoundColors.vue?vue&type=script&lang=js&"
export * from "./WheelHistoryRoundColors.vue?vue&type=script&lang=js&"
import style0 from "./WheelHistoryRoundColors.vue?vue&type=style&index=0&id=1f67b6fd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f67b6fd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f67b6fd')) {
      api.createRecord('1f67b6fd', component.options)
    } else {
      api.reload('1f67b6fd', component.options)
    }
    module.hot.accept("./WheelHistoryRoundColors.vue?vue&type=template&id=1f67b6fd&scoped=true&", function () {
      api.rerender('1f67b6fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/wheel/WheelHistoryRoundColors.vue"
export default component.exports